
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#A3A3A3"}}),_c('rect',{staticClass:"color",attrs:{"width":"38","height":"38","rx":"2","fill":"#A3A3A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 26.58c0-.365.133-.728.4-1.006L21.707 19 15.4 12.426a1.466 1.466 0 010-2.01 1.327 1.327 0 011.93 0l7.272 7.579a1.466 1.466 0 010 2.01l-7.273 7.58a1.327 1.327 0 01-1.929 0A1.448 1.448 0 0115 26.578z","fill":"#EDEDED"}})])
          )
        }
      }
    